import { Api } from "./Api.class";
const endpoint = "recruiter_candidates/recruiter";
const recruiterCandidatAdvisorAPI = new Api(endpoint);
export default recruiterCandidatAdvisorAPI;
